$(function(){

  $(document).on('click', '.condition_table_switch', function(){
      $('.condition_table').toggleClass('open');
  });

  $(document).on('click', '.condition_table', function(){
      $('.condition_table').removeClass('open');
  });


  $('.announcement-bar__message').click(function(e){

  // クリックされたバーに対応する本文を取得
  var $bar = $(this).closest('.announcement-bar');
  var $box = $bar.find('.announce_box');
  var $text = $box.find('.announce_text');

  // 本文が存在しない、または空の場合は何もしない
  if (!$text.length || $.trim($text.text()) === '') {
    return;
  }

  // 本文がある場合のみスライドダウンと背景を表示
  $box.slideDown(300);

  if (!$('.announce_bg').length) {
    $('.announce_message').append('<div class="announce_bg"></div>');
  }

  $('.announce_bg').off('click').on('click', function(){
    $('.announce_box').slideUp(300);
    $(this).remove();
  });
});

$('.announce_close_btn').click(function(){
  $('.announce_bar').slideUp(300);
});

});

// SPフィルター位置調整

$(window).on('load resize scroll', function() {
  const headerHeight = $('header').outerHeight();

  $('.facets-wrapper').css('top', headerHeight + 'px');
});


// SPフィルター高さ調整

document.addEventListener("DOMContentLoaded", function(){

  const header = document.querySelector('.header');
  if(!header) return;

  const rect = header.getBoundingClientRect();
  const headerBottom = rect.bottom;

  document.querySelectorAll('.mobile-facets').forEach(el=>{
    el.style.top = headerBottom + "px";
    el.style.height = "calc(100vh - " + headerBottom + "px)";
  });

});